module.exports = __webpack_public_path__ + "img/dingbu.9440de9e.png";